/**
 * 입력칸 (프로토타입 입회 화면). 라벨 14/600 + 높이 48 입력, 반경 16, hairline.
 * error 를 주면 칸 아래에 붉은 글자로 알리고 aria-invalid 를 겁니다.
 */
import { useId } from 'react';

export function TextField({ label, error = null, hint = null, className = '', ...inputProps }) {
    const inputId = useId();
    const messageId = `${inputId}-message`;
    const message = error ?? hint;

    return (
        <div className={`flex flex-col gap-2 ${className}`}>
            <label htmlFor={inputId} className="text-label">
                {label}
            </label>
            <input
                id={inputId}
                aria-invalid={error ? true : undefined}
                aria-describedby={message ? messageId : undefined}
                className={`h-12 rounded-card border bg-surface px-3.5 text-body text-text-primary placeholder:text-text-tertiary disabled:opacity-40 ${
                    error ? 'border-error' : 'border-hairline'
                }`}
                {...inputProps}
            />
            {message ? (
                <p id={messageId} className={`m-0 text-caption ${error ? 'text-error' : 'text-text-secondary'}`}>
                    {message}
                </p>
            ) : null}
        </div>
    );
}
